import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { ConfigService } from '../../shared/services/config.service';
import { CurrencyService } from '../../shared/services/currency.service';

import { Inspection } from '../../shared/models/index';
import * as _ from 'lodash';

@Component({
    selector: 'inspection-edit',
    templateUrl: './edit.component.html',
    providers: [ConfigService, CurrencyService],
    standalone: false
})
export class InspectionEditComponent implements OnInit, OnChanges {
  private currencies = [];
  @Input() public inspection: Inspection;
  @Output() public toggleSaveInspection: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  @Input() public statusList: any[];
  @Input() public processing;
  @Input() public categories: any[];

  editForm: UntypedFormGroup;
  public coverImages: any[];

  public statusListAugmented: any[];

  constructor(private cdf: ChangeDetectorRef, private configService: ConfigService, private currencyService: CurrencyService) {}

  ngOnInit(): void {
    this.initForm();
    this.configService
      .getResource(`reportcoverimages/${this.configService.applicationTypeName}-images.json`)
      .subscribe((x) => (this.coverImages = x));
    this.currencyService.getCurrencies().subscribe((currencies) => (this.currencies = _.orderBy(_.map(currencies, el=>el.label))));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['statusList'] || changes['inspection']) {
      this.statusListAugmented = this.statusList ? [...this.statusList] : [];
      if (this.statusList && this.inspection && !this.statusListAugmented.includes(this.inspection.status)) {
        this.statusListAugmented.push(this.inspection.status);
        this.statusListAugmented = _.orderBy(this.statusListAugmented);
      }
    }
  }

  public updateInspection(model: any) {
    this.inspection.name = model.name;
    this.inspection.description = model.description;
    this.inspection.status = model.status;
    this.inspection.category = parseInt(model.category);
    this.inspection.coverImage = parseInt(model.coverImage);
    this.inspection.currency = model.currency;
    this.inspection.hourlyRate = model.hourlyRate;
    this.toggleSaveInspection.emit(this.inspection);
  }

  public cancel() {
    this.toggleCancel.emit();
  }

  initForm() {
    this.editForm = new UntypedFormGroup({
      name: new UntypedFormControl(this.inspection?.name ?? '', Validators.required),
      description: new UntypedFormControl(this.inspection?.description ?? ''),
      status: new UntypedFormControl(this.inspection?.status ?? 0, Validators.required),
      tplName: new UntypedFormControl(this.inspection?.tplName ?? ''),
      coverImage: new UntypedFormControl(this.inspection?.coverImage ?? 0),
      category: new UntypedFormControl(this.inspection?.category ?? 0),
      hourlyRate: new UntypedFormControl(this.inspection?.hourlyRate),
      currency: new UntypedFormControl(this.inspection?.currency)
    });
  }
}
